import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import EmployeeDataImportListRequest from "../request/EmployeeDataImportListRequest";
import EmployeeDataImportListApiResponse from "../model/EmployeeDataImportListApiResponse";

export const EmployeeDataImportListApiService = async (request: EmployeeDataImportListRequest): Promise<EmployeeDataImportListApiResponse[]> => {
  const url = "/employeeimportfiles/";
  const { data } = await axios.get(url, {
    params: request
  });
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useEmployeeDataImportListApiService = (request: EmployeeDataImportListRequest
) =>
  useQuery<Promise<EmployeeDataImportListApiResponse[]>, AxiosError, EmployeeDataImportListApiResponse[]>(
    ["EmployeeDataImportListApiService", ...Object.values(request)], () =>
      EmployeeDataImportListApiService(request), { keepPreviousData : true }
  );

export default useEmployeeDataImportListApiService;